var _excluded = ["label", "floatingLabel", "condensed", "light", "hideErrorIndicator", "hideRequiredIndicator", "description", "error", "autocomplete", "className", "format", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import { isEmpty } from '../../utilities';
import Label from './Label';
var TextControl = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _input$id;
  var label = _ref.label,
    _ref$floatingLabel = _ref.floatingLabel,
    floatingLabel = _ref$floatingLabel === void 0 ? false : _ref$floatingLabel,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light,
    _ref$hideErrorIndicat = _ref.hideErrorIndicator,
    hideErrorIndicator = _ref$hideErrorIndicat === void 0 ? false : _ref$hideErrorIndicat,
    _ref$hideRequiredIndi = _ref.hideRequiredIndicator,
    hideRequiredIndicator = _ref$hideRequiredIndi === void 0 ? false : _ref$hideRequiredIndi,
    description = _ref.description,
    error = _ref.error,
    _ref$autocomplete = _ref.autocomplete,
    autocomplete = _ref$autocomplete === void 0 ? 'on' : _ref$autocomplete,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    format = _ref.format,
    value = _ref.value,
    input = _objectWithoutProperties(_ref, _excluded);
  var errId = error ? "errMessage-".concat(input.name) : null;
  input.id = (_input$id = input.id) !== null && _input$id !== void 0 ? _input$id : input.name;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-input".concat(className ? " ".concat(className) : '').concat(floatingLabel ? ' cb-floating-label' : '').concat(condensed ? ' cb-input-condensed' : '').concat(error ? ' cb-validation-error' : '').concat(input.disabled ? ' cb-disabled' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-validation-label-input"
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: input.id,
    required: input.required && !hideRequiredIndicator,
    light: light
  }), description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, description)) : null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    value: format ? format(value) : value,
    type: input.type || 'text',
    autoComplete: autocomplete,
    ref: ref,
    "aria-describedby": errId,
    "aria-invalid": !isEmpty(error),
    "aria-required": input.required
  }))), error && !hideErrorIndicator ? /*#__PURE__*/React.createElement("i", {
    className: "cb-validation-icon cb-icon cb-exclamation",
    "aria-hidden": true
  }) : null), error ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-input-helper cb-validation-error",
    "aria-live": "polite"
  }, error) : null);
});
TextControl.displayName = 'Text';
export default TextControl;

//${input.required && !hideRequiredIndicator ? ' cb-required' : ''}